import { render, staticRenderFns } from "./BulkReportContainer.vue?vue&type=template&id=2f6aadc8&scoped=true&"
import script from "./BulkReportContainer.vue?vue&type=script&lang=js&"
export * from "./BulkReportContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6aadc8",
  null
  
)

export default component.exports